module.exports = __webpack_public_path__ + "static/media/sub6.31f92a97.png";